import React from 'react';
import { hasScrolledIntoView } from '../hasScrolledIntoView';
import { StyledAvatar, StyledAvatarBackground, StyledAvatarText } from './Avatar.styled';
function _Avatar(props) {
  var size = props.size || 32;
  return /*#__PURE__*/React.createElement(StyledAvatar, {
    style: {
      width: size,
      height: size,
      // arbitrary design match scaling value. seems to look close match in all sizes.
      fontSize: Math.round(size * 0.45),
      color: props.color
    },
    "data-testid": props['data-testid-suffix'] ? "citrix-ui-avatar-".concat(props['data-testid-suffix']) : 'citrix-ui-avatar'
  }, props.hasScrolledIntoView && props.src && /*#__PURE__*/React.createElement(StyledAvatarBackground, {
    style: {
      backgroundImage: "url(".concat(props.src, ")")
    },
    "data-testid": props['data-testid-suffix'] ? "citrix-ui-avatar-image-".concat(props['data-testid-suffix']) : 'citrix-ui-avatar-image'
  }), /*#__PURE__*/React.createElement(StyledAvatarText, null, props.label ||
  /*#__PURE__*/
  /* needs specifically &nbsp; to prevent layout issues. */
  React.createElement(React.Fragment, null, "\xA0")));
}
export var Avatar = hasScrolledIntoView(_Avatar);